import { html } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { ChameleonElementMixin } from '../../common/mixin';
export const progressStepPanelTemplate = html `<template slot="steppanel">
  <slot></slot>
</template>`;
export class ProgressStepPanelComponent extends ChameleonElementMixin(FoundationElement) {
}
